import { createSlice, isRejectedWithValue } from '@reduxjs/toolkit';
import {
	loginUser, 
	logoutUser, 
	registerUser, 
	confirmUser,
	getSession, 
	updateUser,
	confirmUserEmailChange,
} from './authActions';

export const UserStatus = {
	PENDING: 0,
	ACTIVE: 1,
	INACTIVE: 2,
	DELETED: 3,
	BANNED: 4,
};

export const initialState = {
	loading: false,
	user: null,
	isLogged: false,
	profileList: [],
	accessToken: "",
	error: null,
	success: false,
};
	
const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setCredentials: (state, action) => {
			state.accessToken = action.payload.accessToken;
			state.profileList = action.payload.profileList;
		},
		setUser: (state, action) => {
			state.user = {...state.user, ...action.payload}
		}
	},
	extraReducers: (builder) => {
		builder
		.addCase(getSession.pending, (state) => {
			state.loading = true;
		})
		.addCase(getSession.fulfilled, (state, action) => {
			state.loading = false;
			state.user = action.payload.user;
			state.profileList = action.payload.profileList;
			state.isLogged = true;
			state.accessToken = action.payload.accessToken;
			state.error = null;
		})
		.addCase(getSession.rejected, (state) => {
			return initialState;
		})
		.addCase(loginUser.pending, (state) => {
			state.loading = true;
		})
		.addCase(loginUser.fulfilled, (state, action) => {
			state.isLogged = true;
			state.loading = false;
			state.user = action.payload.user;
			state.profileList = action.payload.profileList;
			state.accessToken = action.payload.accessToken;
			state.error = null;
		})
		.addCase(loginUser.rejected, (state, action) => {
			state.loading = false;
			state.isLogged = false;
			state.error = action.payload.error;
		})
		.addCase(logoutUser.pending, (state) => {
			state.loading = true;
		})
		.addCase(logoutUser.fulfilled, (state) => {
			return initialState;
		})
		.addCase(logoutUser.rejected, (state, action) => {
			return initialState;
		})
		.addCase(registerUser.pending, (state) => {
			state.loading = true;
		})
		.addCase(registerUser.fulfilled, (state, action) => {
			state.loading = false;
			state.isLogged = true;
			state.accessToken = action.payload.accessToken;
			state.user = action.payload.user;
			state.error = null;
			state.success = true;
		})
		.addCase(registerUser.rejected, (state, action) => {
			state.loading = false;
			state.success = false;
			state.isLogged = false;
			state.error = action.payload.error;
		})
		.addCase(confirmUser.pending, (state) => {
			state.loading = true;
		})
		.addCase(confirmUser.fulfilled, (state, action) => {
			state.loading = false;
			state.user = action.payload;
			state.error = null;
			state.success = true;
		})
		.addCase(confirmUser.rejected, (state, action) => {
			state.loading = false;
			state.success = false;
			state.error = action.payload.error;
		})		
		.addCase(updateUser.fulfilled, (state, action) => {
			state.user = action.payload;
		})
		.addCase(confirmUserEmailChange.fulfilled, (state, action) => {
			state.user = action.payload;
		})
		.addMatcher(
			isRejectedWithValue,
			(state, action) => {
				state.loading = false;
				state.error = action.payload || 'Something went wrong';
			}
		);
	},
});

export default authSlice.reducer;
export const { setUser } = authSlice.actions;
